import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AcessoService } from 'src/app/service/acesso/acesso.service';
import { LocalStorage } from 'src/app/service/classes/localstorage/LocalStorage';
import { Crypto } from 'src/app/service/classes/crypto/crypto';

@Injectable ({
    providedIn: 'root',
})

export class LotacoesVinculadasService {
  localStorage: LocalStorage = new LocalStorage();
  headers = new HttpHeaders();
  url_acesso: string;
  cabecalho: any;
  filial: string;

  constructor(private http: HttpClient, private acesso: AcessoService) {
    this.url_acesso = this.acesso.validarUrl();

    if (localStorage.getItem('util') != null) {
      this.localStorage = JSON.parse(new Crypto().decryptUsingAES256(localStorage.getItem('util')));
      this.cabecalho = this.headers.append('sessao', this.localStorage.Sessao);

      this.filial = this.localStorage.FilialAtual.toString();
    }
  }

  buscarColaboradorMatricula(matricula: string) {
    return this.http.get(`${this.url_acesso}cadastro-todos-matricula/${matricula}/${this.filial}`, {
      headers: this.cabecalho,
    });
  }

    buscarLotacao() {
        return this.http.get(`${this.url_acesso}lotacoes-vinculadas/listar-completa`, {
        headers: this.cabecalho,
        });
    }

    buscarLotacaoModal(Codigo: number) {
      return this.http.get(`${this.url_acesso}lotacoes-vinculadas/${Codigo}`, {
      headers: this.cabecalho,
      });
  }

  adicionarLotacao(lotacao: any) {
        return this.http.post(`${this.url_acesso}lotacoes-vinculadas`, lotacao, {
            headers: this.cabecalho,
        });
    }

    editarLotacao(lotacao: any) {
      return this.http.put(`${this.url_acesso}lotacoes-vinculadas/${lotacao.Codigo}`, lotacao,{
        headers: this.cabecalho,
      });
      
    }
    

    deletarLotacao(Codigo: number) {
        return this.http.delete(`${this.url_acesso}lotacoes-vinculadas/${Codigo}`, {
            headers: this.cabecalho,
        });
    }


    buscarTiposLotacao(empresaFilial: string) {
        return this.http.get(`${this.url_acesso}lotacoes-vinculadas/tipos-lotacao/${empresaFilial}`, {
            headers: this.cabecalho,
        });
    }
}